export default __webpack_public_path__ + "static/media/Bungee-Regular.3d95fa68.ttf";